import React from "react";

function Footer() {
  return (
    <footer className="w-full flex justify-center items-center p-4 md:p-8 dark:bg-supper-black">
      <h1 className=" text-supper-med-gray dark:text-supper-light-gray">
        Copyright © Supper House 2022
      </h1>
    </footer>
  );
}

export default Footer;
